import { TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from 'react'
import { useSession } from './SessionContext';

export default function CreateDistrict() {
    const [data, setData] = useState([]);
    const [DTID, setDTID] = useState('');
    const [stateName, setStateName] = useState('');
    const [stateNameId, setStateNameId] = useState('');
    const [stateNameOptions, setStateNameOptions] = useState([]);
    const [cityName, setCityName] = useState('');
    const [errors, setErrors] = useState('');
    const [DeleteId, setDeleteId] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [failureMessage, setFailureMessage] = useState('');
    const [isDeleted, setIsDeleted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'Dashboard', url: '/Dashboard' }]);
    const location = useLocation();
    const { userLoginType, setUserLoginType } = useSession();

    useEffect(() => {
        var loginType = document.cookie.replace(/(?:(?:^|.*;\s*)loginType\s*=\s*([^;]*).*$)|^.*$/, "$1");

        if (loginType) {
            setUserLoginType(loginType);
        }
    }, [setUserLoginType]);

    const handleStateNameChange = (e) => {
        const value = e.target.value
        setStateName(value);
        const selctedState = stateNameOptions.find(option => option.name === value)
        if(selctedState){
            setStateNameId(selctedState.id)
        }
        setErrors((prevErrors) => ({
            ...prevErrors,
            stateName: value ? '' : 'Please Enter State Name'
        }));
    }

    const handleCityNameChange = (e) => {
        const value = e.target.value
        setCityName(value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            cityName: value ? '' : 'Please Enter City Name'
        }));
    }

    useEffect(() => { 
        const fetchState = async () => {
            try {
              const response = await fetch(`/api/getStates`, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });
      
              if (response.ok) {
                const data = await response.json();
                const filteredOptions = data.recordset.filter(option => option.StateName !== null).map(option => ({
                    name: option.StateName,
                    id: option.STID,
                }));
                setStateNameOptions(filteredOptions);
              }
            } catch (error) {
              console.error('Internal Server Error');
            }
        };

        fetchState(); 
    }, []);

    const removeSuccessMessage = () => {
        setSuccessMessage('');
        setShowModal(false);
    };

    const handleReset = () => {
        setStateName('');
        setStateNameId('');
        setCityName('');
        setDTID('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) {
            return;
        }

        if (!stateNameId || !cityName ) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                stateNameId: !stateNameId ? 'State is required' : prevErrors.stateNameId,
                cityName: !cityName ? 'City is required' : prevErrors.cityName,
            }));

            setLoading(false);
            setIsSubmitting(false);
            return;
        }

        setIsSubmitting(true);
        setLoading(true);

        if (DTID) {
            try {
                const response = await fetch(`/api/UpdateCities/${DTID}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ stateNameId, cityName, userLoginType }),
                });
                if (response.ok) {
                    const Data = await response.json();
                    setShowModal(true);
                    setFailureMessage('');
                    setSuccessMessage(Data.message);
                    setTimeout(() => {
                        removeSuccessMessage();
                    }, 1000);
                    handleReset();
                    fetchDistricts();
                } else {
                    const Data = await response.json();
                    setShowModal(true);
                    setSuccessMessage('');
                    setFailureMessage(Data.error);
                    setTimeout(() => {
                        removeSuccessMessage();
                    }, 1000);
                }
            } catch (error) {
                console.error('Internal Server Error');
            } finally {
                setLoading(false);
            }
        } else {
            try {
                const response = await fetch(`/api/CreateCity`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ stateNameId, cityName, userLoginType }),
                });

                if (response.ok) {
                    const Data = await response.json();
                    setShowModal(true);
                    setFailureMessage('');
                    setSuccessMessage(Data.message);
                    setTimeout(() => {
                        removeSuccessMessage();
                    }, 1000);
                    handleReset();
                    fetchDistricts();
                } else {
                    const Data = await response.json();
                    setShowModal(true);
                    setSuccessMessage('');
                    setFailureMessage(Data.error);
                    setTimeout(() => {
                        removeSuccessMessage();
                    }, 1000);
                }
            } catch (error) {
                console.error('Internal Server Error');
            } finally {
                setLoading(false);
            }
        }
        setIsSubmitting(false);
    };

    useEffect(() => {
        fetchDistricts();
    }, []);

    const fetchDistricts = async () => {
        try {
            const response = await fetch(`/api/getCities`);
            const data = await response.json();

            const dataArray = data.recordset;
            if (Array.isArray(dataArray)) {
                setData(dataArray);
            } 
        } catch (error) {
            console.error('Error fetching options:');
        }
    };

    useEffect(() => {
        if (DTID) {
            fetch(`/api/getUpdateCities/${DTID}`)
                .then((response) => response.json())
                .then((result) => {
                    if (result && result.length > 0) {
                        const clientdata = result[0];
                        setStateName(clientdata.StateName || '');
                        setStateNameId(clientdata.STID || '');
                        setCityName(clientdata.DistName || '');
                    }
                })
                .catch((error) => {
                    console.error('Internal Server Error');
                });
        }
    }, [DTID]);

    const handleEditClick = (DTID) => {
        setDTID(DTID);
    };

    const handleConfirmation = async (DTID) => {
        setIsDeleted(true);
        setDeleteId(DTID)
    };

    const handleCancel = async () => {
        setIsDeleted(false);
        setDeleteId('')
    };

    const handleDelete = async (DTID) => {
        try {
            const response = await fetch(`/api/DeleteCities/${DTID}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                setData((prevData) => prevData.filter(item => item.DTID !== DTID));
                const Data = await response.json();
                setIsDeleted(false)
                setShowModal(true);
                setFailureMessage('');
                setSuccessMessage(Data.message);
                setTimeout(() => {
                    removeSuccessMessage();
                }, 2000);
                DeleteId('');
            } else {
                const Data = await response.json();
                setIsDeleted(false);
                setShowModal(true);
                setSuccessMessage('');
                setFailureMessage(Data.error);
                setTimeout(() => {
                    removeSuccessMessage();
                }, 2000);
            }
        } catch (error) {
            console.error('Error deleting Class:', error);
        }
    };

    useEffect(() => {
        const currentRoute = location.pathname;
        const newBreadcrumbs = generateBreadcrumbs(currentRoute);
        setBreadcrumbs(newBreadcrumbs);
    }, [location]);

    const generateBreadcrumbs = (currentRoute) => {
        const breadcrumbsArray = [{ label: 'Dashboard', url: '/Dashboard' }];

        const routeParts = currentRoute.split('/').filter(Boolean);
        let urlSoFar = '';
        routeParts.forEach((part) => {
            urlSoFar += `/${part}`;
            breadcrumbsArray.push({ label: part, url: urlSoFar });
        });

        return breadcrumbsArray;
    };

    return (
        <>
            {showModal && (
                <div className="modal-backdrop show"></div>
            )}
            <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
                        <div className="modal-header">
                            <h5 className="modal-title">Success Message</h5>
                        </div>
                        <div className="modal-body">
                            {successMessage && <p className='text-success'>{successMessage}</p>}
                            {failureMessage && <p className='text-danger'>{failureMessage}</p>}
                        </div>
                    </div>
                </div>
            </div>

            <div className='my-2 mobile-margin mx-2'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        {breadcrumbs.map((breadcrumb, index) => (
                            <li key={index} className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}>
                                {index === breadcrumbs.length - 1 ? (
                                    breadcrumb.label
                                ) : (
                                    <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>

                <div className='shadow-sm p-3 mb-3 bg-white rounded'>
                    <div className='row d-flex align-items-center'>
                        <div className='col-6 col-md-3 mb-2'>
                            <FormControl variant="standard" fullWidth error={!!errors.stateNameId}>
                              <InputLabel id="demo-simple-select-standard-label">Select State</InputLabel>
                              <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={stateName} onChange={handleStateNameChange}>
                                {stateNameOptions.map((option, index) => (
                                    <MenuItem key={index} value={option.name}>{option.name}</MenuItem>
                                ))}
                              </Select>
                              <FormHelperText>{errors.stateNameId}</FormHelperText>
                            </FormControl>
                        </div>
                        <div className='col-6 col-md-3 mb-2'>
                            <TextField label="City Name" variant="standard" fullWidth value={cityName} onChange={handleCityNameChange} helperText={errors.cityName} error={!!errors.cityName} />
                        </div>
                        <div className='col-6 col-md-3'>
                            <Button variant="contained" color="primary" fullWidth onClick={handleSubmit} >{DTID ? 'Update' : 'Save'}</Button>
                        </div>
                        <div className='col-6 col-md-3'>
                            <Button variant="contained" color="secondary" fullWidth onClick={handleReset}>Reset</Button>
                        </div>
                    </div>
                </div>

                <div className='shadow mb-5 rounded' style={{ maxHeight: '100vh', overflowY: 'auto' }}>
                    <table className='table table-nowrap mb-0 mt-0'>
                        <thead className='table-primary' style={{ position: 'sticky', top: '0', zIndex: '1', marginTop: '1rem' }}>
                            <tr>
                                <th>State</th>
                                <th>District</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.StateName}</td>
                                    <td>{item.DistName}</td>
                                    <td><p className='badge badge-warning-lighten' onClick={() => handleEditClick(item.DTID)}><i className="bi bi-pencil-square fs-6"></i></p></td>
                                    <td><p className='badge badge-danger-lighten mx-2' onClick={() => handleConfirmation(item.DTID)}><i className="bi bi-trash-fill fs-6"></i></p></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {isDeleted && (
                    <div className="modal-backdrop show"></div>
                )}
                <div className={`modal fade ${isDeleted ? 'show' : ''}`} style={{ display: isDeleted ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
                            <div className="modal-header">
                                <h5 className="modal-title">Delete <strong>District?</strong></h5>
                            </div>
                            <div className="modal-body">
                                <p>This Will Delete District <span className='text-danger'>Permannently</span></p>
                                <div className='d-flex flex-row-reverse '>
                                    <button className='btn btn-danger mx-2' onClick={() => handleDelete(DeleteId)}>Delete</button>
                                    <button className='btn btn-secondary mx-2' onClick={handleCancel}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {loading && (
                <div className="modal-backdrop show"></div>
            )}
            <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered text-center modal-sm" role="document">
                    <div className="modal-content shadow-lg bg-white rounded modal-m-sm">
                        <div className="modal-body text-center my-2 mx-2">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
